var youboralib = require('youboralib')

module.exports = {
  isUsed: function (adapter) {
    return !!adapter.getTech().shakaPlayer
  },

  getResource: function (adapter) {
    return adapter.getTech().shakaPlayer.getManifestUri()
  },

  getBitrate: function (adapter) {
    return adapter.getTech().shakaPlayer.getStats().streamBandwidth
  },

  getRendition: function (adapter) {
    var shaka = adapter.getTech().shakaPlayer
    var stats = shaka.getStats()
    var ret = youboralib.Util.buildRenditionString(stats.width, stats.height, stats.streamBandwidth)
    var tracks = shaka.getVariantTracks()
    for (var i in tracks) {
      var track = tracks[i]
      if (track.active && track.type === 'video') {
        ret = youboralib.Util.buildRenditionString(track.width, track.height, track.bandwidth)
        break
      }
    }
    return ret
  }
}
